import { vars } from "@styles/theme.css"
import Heading from "components/Heading"
import ButtonLink from "components/shared/ButtonLink"
import { Trans } from "next-i18next"

import * as s from "./AlreadyExistsView.css"

type Props = {
  data: any
}

function AlreadyExistsView({ data = {} }: Props) {
  return (
    <div className={s.wrapper}>
      <div className={s.innerWrapper}>
        <Heading color={vars.colors.primary.light} variant="3">
          <Trans
            i18nKey="alreadyExistsView.message"
            components={[
              <ButtonLink
                variant="link"
                href={`/resumen-de-llamadas-y-sentiment-analysis-IA/${data?.id}/resultado`}
              />,
            ]}
          />
        </Heading>
      </div>
    </div>
  )
}

export default AlreadyExistsView
export type { Props as AlreadyExistsViewProps }
